import config from "../config";

//@ts-ignore
const HOST = (typeof NODE_ENV !== 'undefined' && NODE_ENV === "production") ? "api.airfind.com" : "api.dev.airfind.com";

const LABELLER_API = `//${HOST}/d2s-labeller`;
const DELIVERY_API = `//${HOST}/d2s/v1`;

const postHeaders = { "Content-Type": "application/json" };

const get = (url) => fetch(url).then((res) => res.json());
const post = (url, data) =>
  fetch(url, { method: "POST", headers: postHeaders, mode: "cors", body: JSON.stringify(data) }).then((res) =>
    res.json()
  );

// export const getCategory = (text) => get(`${LABELLER_API}?text=${encodeURIComponent(text)}`);
export const getCategory = (text = []) => post(LABELLER_API, { text });

export const getKeywords = (category, c = config) =>
  get(
    `${DELIVERY_API}?categoryId=${"IAB" + category}&limit=${c.termsQuantity}&clientId=${c.clientId}&affiliateId=${
      c.brand
    }&urlPattern=${
      "m.1news.io" // window.location.hostname
    }&ua=${navigator.userAgent}&d2sLandingPage=${c.d2sLandingPage}&searchTerm=${c.searchTerm}`
  );
